/**
 * Extrae el id de ambiente embebido en links de notificaciones WEB.
 */
export default function getEnvironmentIdFromNotificationUrl(url) {
    if (!url || typeof url !== "string") {
        return null;
    }

    const massManageMatch = url.match(/\/echeqs\/mass-management\/(\d+)\//);
    if (massManageMatch) {
        return massManageMatch[1];
    }

    const echeqSingleMatch = url.match(/\/echeqs\/single\/(\d+)\//);
    if (echeqSingleMatch) {
        return echeqSingleMatch[1];
    }

    const echeqSummaryMatch = url.match(/\/echeqs\/summary\/(\d+)\//);
    if (echeqSummaryMatch) {
        return echeqSummaryMatch[1];
    }

    const genericMatch = url.match(/\/(\d+)\//);
    return genericMatch ? genericMatch[1] : null;
}
